import { APY_INPUT_PATTERN } from '../../constants';
import type { CdCalculatorFormFieldsKeys, CdCalculatorStore } from './types';

type FireCdCalculatorInteracted = (args: {
  additional_attributes: {
    annual_percentage_yield_value_input: string;
    initial_deposit_value_input: string;
    term_length_value_input: string;
    term_length_unit_value_input: string;
  };
}) => void;

export type HandleAnnualApyInputContext = {
  fireCdCalculatorInteractedPageAction: FireCdCalculatorInteracted;
  fireFieldInteracted?: (value: string) => void;
  initialDeposit: string;
  termLength: string;
  termLengthUnit: string;
  setField: CdCalculatorStore['setField'];
  startTransition: (fn: () => void) => void;
};

export function handleAnnualApyInput(value: string, ctx: HandleAnnualApyInputContext): void {
  if (!APY_INPUT_PATTERN.test(value)) {
    return;
  }

  const {
    fireCdCalculatorInteractedPageAction,
    fireFieldInteracted,
    initialDeposit,
    termLength,
    termLengthUnit,
    setField,
    startTransition,
  } = ctx;

  const field: CdCalculatorFormFieldsKeys = 'annualPercentageYield';

  startTransition(() => {
    fireCdCalculatorInteractedPageAction({
      additional_attributes: {
        annual_percentage_yield_value_input: value,
        initial_deposit_value_input: initialDeposit,
        term_length_value_input: termLength,
        term_length_unit_value_input: termLengthUnit,
      },
    });
    fireFieldInteracted?.(value);
    setField(field, value);
  });
}
